
import getItemUnit from "./getItemUnit";
import getInfoSize from "./getInfoSize";
import getItemColor from "./itemColor";
import getInfoWantedPrice from "./getInfoWantedPrice";

export default function getInfoData(dataType,itemID,callback){
    let currentTimestamp = Date.now();

    if(dataType==="info"){
        getInfoContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"td");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }else if(dataType==="infoYouKe"){
        getInfoYouKeContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"td");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }else if(dataType==="distributeYouKe"){
        getDistributeYouKeContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"fx");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }else if(dataType==="distributeAdmin"){
        getDistributeAdminContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"fx");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }else if(dataType==="infoAdmin"){
        getInfoAdminContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"td");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }else if(dataType==="queryAdmin"){
        getQueryAdminContent(itemID,currentTimestamp,function(output,infoBaseData,targetData,infoDetailsData){
            setNotification(targetData.id(),"xd");
            callback(output,currentTimestamp,infoBaseData,targetData,infoDetailsData);
        });
    }
}

function setNotification(targetID,type){
    let key = "";

    switch(type){
      case 'td':
        key = "u2diInfoBase";
        break;
      case 'fx':
        key = "u2diInfoDistributes";
        break;
      case 'xd':
        key = "u2diInfoQueries";
        break;
    }

    app.store
    .createRecord("u2diNotificationSet")
    .save({targetID:targetID,type:type})
    .then((respond) => {
        const result = respond.attribute("result");

        if(result===true){
            app.store.getById(key,targetID).data.attributes.nid = targetID;
            app.store.getById("u2diNotification","").data.attributes[type]-=1;
            m.redraw();
        }
    })
}

function getQueryAdminContent(itemID,currentTimestamp,callback){
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    app.store
      .find("u2diInfoQueries",{
        itemID:window.selectedTargetID,
        })
      .catch(() => {})
      .then((result) => {
        const infoQueryData = result[0];
        const u2diUserData = infoQueryData.u2diUserData();
        const userSigned = u2diUserData?u2diUserData.attribute("u2diUserSigned"):0;

        const infoBaseData = infoQueryData.u2diBaseData();
        const infoDetailsData = infoQueryData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoCategory = infoBaseData.category();
        const infoNote = infoQueryData.note()===null?"":infoQueryData.note();
        const infoUserType = app.translator.trans("ziven-u2di.forum.user-type-"+infoBaseData.userType());
        const infoType = infoBaseData.type();
        const itemColor = getItemColor(infoType);

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const xdxx = JSON.parse(CryptoJSAesJson.decrypt(infoQueryData.xdxx(), (infoDetailsData.base_id()).toString()));
        const option_zsxm = xdxx.option_zsxm;
        const option_zsxm_title = app.translator.trans("ziven-u2di.forum.option-zsxm-"+xdxx.option_zsxm_title);
        const option_lxdh = xdxx.option_lxdh;
        const option_lxdh_wx_value = xdxx.option_lxdh_wx_value;
        const option_wx = xdxx.option_lxdh_checked===1?option_lxdh_wx_value:"同手机";
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+zcxx.option_zclb);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        const option_zcdb = app.translator.trans("ziven-u2di.forum.option-zcdb-"+zcxx.option_zcdb);

        let infoName = option_zcqs+option_lzxz+option_zclb;
        const infoSignedMark = infoBaseData.signedMark();
        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-left: 5px;color: #04aa41;font-size: 14px;"><i class="fas fa-check-circle"></i></span>';
        }

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);
        const infoFlag = infoBaseData.flag();

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }

        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let infoDetails = "";
        if(u2diUserType9===true){
            infoDetails = "<span class='u2diItemInfoDetailsButton' id='u2diItemInfoDetailsButton"+currentTimestamp+"'>详情</span>";
        }

        let info = [];

        info.push('<div style="width:360px;color: var(--control-color);padding: 0px 5px;">');

        info.push('<div class="u2diItemDetailsHeaderContainier">');
        info.push('<div style="font-size:20px;margin-top: -10px;text-align: center;"><div>'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span>'+infoDetails+'</div><div style="font-size: 12px;text-align: center;padding-top: 5px;display: flex;justify-content: center;align-items: center;"><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'次'+infoVerifiedSign+'<span style="margin-left:5px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div></div>');
        info.push('<div style="width: 200px;">');
        info.push('<div class="u2diItemDetailsInfoSlimContainer">');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoAreaSize+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+option_synx+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoWantedPrice+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');

        info.push('<div style="text-align: center;padding-top:0px;" class="u2diItemDetailsViewsContainier">');
        info.push('<div style="width: 140px;">');
        info.push('<div style="font-size: 12px;color: var(--primary-color);">'+infoName+'</div>');
        info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">有'+infoDistributes+'人分销，有'+infoQueries+'人询地</div>');
        info.push('<div style="font-size: 16px;color: '+(userSigned===0?'var(--primary-color)':'#A17EFF')+';padding-top: 10px;">'+option_zsxm+' <span style="font-size: 12px;color: gray;">'+option_zsxm_title+'</span> <span style="font-size: 12px;color: #D9001B;">(询地)</span></div>');
        info.push('<div style="font-size: 16px;color: #D9001B;padding-top: 12px;">'+option_lxdh+'</div>');
        info.push('<div style="font-size: 10px;color: gray;padding-top: 5px;">（微信 '+option_wx+'）</div>');
        info.push('</div>');
        info.push('<div style="position:relative">');
        info.push('<textarea id="u2diInfoNoteInputArea'+currentTimestamp+'" style="width: 200px;height: 120px;border: 0px;border-radius: 4px;resize: none;padding: 5px;">'+infoNote+'</textarea><div style="display:none;position: absolute;right: 8px;bottom: 8px;" id="u2diInfoNoteInputAreaStatus'+currentTimestamp+'">询地笔记 已保存</div>');
        info.push('</div>');

        info.push('</div>');


        info.push('</div>');

        callback(info.join(""),infoBaseData,infoQueryData,infoDetailsData);
    });
}

function getDistributeYouKeContent(itemID,currentTimestamp,callback){
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    app.store
      .find("u2diInfoDistributes/y",{itemID:itemID})
      .catch(() => {})
      .then((result) => {
        const infoDistributeData = result[0];

        const infoBaseData = infoDistributeData.u2diBaseData();
        const infoDetailsData = infoDistributeData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoCategory = infoBaseData.category();
        const infoNote = infoDistributeData.note()===null?"":infoDistributeData.note();
        const infoUserType = app.translator.trans("ziven-u2di.forum.user-type-"+infoDistributeData.userType());
        const infoType = infoBaseData.type();
        const itemColor = getItemColor(infoType);

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const fxxx = JSON.parse(CryptoJSAesJson.decrypt(infoDistributeData.fxxx(), (infoDetailsData.base_id()).toString()));
        const option_zsxm = fxxx.option_zsxm;
        const option_zsxm_title = app.translator.trans("ziven-u2di.forum.option-zsxm-"+fxxx.option_zsxm_title);
        const option_lxdh = fxxx.option_lxdh;
        const option_lxdh_wx_value = fxxx.option_lxdh_wx_value;
        const option_wx = fxxx.option_lxdh_checked===1?option_lxdh_wx_value:"同手机";
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+zcxx.option_zclb);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        const option_zcdb = app.translator.trans("ziven-u2di.forum.option-zcdb-"+zcxx.option_zcdb);

        let infoName = option_zcqs+option_lzxz+option_zclb;
        const infoSignedMark = infoBaseData.signedMark();
        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-left: 5px;color: #04aa41;font-size: 14px;"><i class="fas fa-check-circle"></i></span>';
        }

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);
        const infoFlag = infoBaseData.flag();

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }

        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let infoDetails = "";
        if(u2diUserType0===true){
            infoDetails = "<span class='u2diItemInfoDetailsButton' id='u2diItemInfoDetailsButton"+currentTimestamp+"'>详情</span>";
        }

        let info = [];

        info.push('<div style="width:360px;color: var(--control-color);padding: 0px 5px;">');

        info.push('<div class="u2diItemDetailsHeaderContainier">');
        info.push('<div style="font-size:20px;margin-top: -10px;text-align: center;"><div>'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span>'+infoDetails+'</div><div style="font-size: 12px; text-align: center; padding-top: 5px; display: flex; align-items: center; justify-content: center;"><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'次'+infoVerifiedSign+'<span style="margin-left:5px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div></div>');
        info.push('<div style="width: 200px;">');
        info.push('<div class="u2diItemDetailsInfoSlimContainer">');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoAreaSize+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+option_synx+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoWantedPrice+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');

        info.push('<div style="text-align: center;padding-top:0px;" class="u2diItemDetailsViewsContainier">');
        info.push('<div style="width: 140px;">');
        info.push('<div style="font-size: 12px;color: var(--primary-color);">'+infoName+'</div>');
        info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">有'+infoDistributes+'人分销，有'+infoQueries+'人询地</div>');
        info.push('<div style="font-size: 16px;color: var(--primary-color);padding-top: 10px;">'+option_zsxm+' <span style="font-size: 12px;color: gray;">'+option_zsxm_title+'</span> <span style="font-size: 12px;color: #70B603;">('+infoUserType+')</span></div>');
        info.push('<div style="font-size: 16px;color: #70B603;padding-top: 10px;">'+option_lxdh+'</div>');
        info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">（微信 '+option_wx+'）</div>');
        info.push('</div>');
        info.push('<div style="position:relative">');
        info.push('<textarea id="u2diInfoNoteInputArea'+currentTimestamp+'" style="width: 200px;height: 120px;border: 0px;border-radius: 4px;resize: none;padding: 5px;">'+infoNote+'</textarea><div style="display:none;position: absolute;right: 8px;bottom: 8px;" id="u2diInfoNoteInputAreaStatus'+currentTimestamp+'">分销笔记 已保存</div>');
        info.push('</div>');

        info.push('</div>');


        info.push('</div>');

        callback(info.join(""),infoDistributeData,infoDistributeData,infoDetailsData);
    });
}

function getDistributeAdminContent(itemID,currentTimestamp,callback){
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    app.store
      .find("u2diInfoDistributes/a",{itemID:itemID,targetID:window.selectedTargetID})
      .catch(() => {})
      .then((result) => {
        const infoDistributeData = result[0];
        const u2diUserData = infoDistributeData.u2diUserData();
        const userSigned = u2diUserData?u2diUserData.attribute("u2diUserSigned"):0;

        const infoBaseData = infoDistributeData.u2diBaseData();
        const infoDetailsData = infoDistributeData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoCategory = infoBaseData.category();
        const infoNote = infoDistributeData.note()===null?"":infoDistributeData.note();
        const infoUserType = app.translator.trans("ziven-u2di.forum.user-type-"+infoDistributeData.userType());
        const infoType = infoBaseData.type();
        const infoSignedMark = infoBaseData.signedMark();
        const itemColor = getItemColor(infoType);

        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-left: 5px;color: #04aa41;font-size: 14px;"><i class="fas fa-check-circle"></i></span>';
        }

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const fxxx = JSON.parse(CryptoJSAesJson.decrypt(infoDistributeData.fxxx(), (infoDetailsData.base_id()).toString()));
        const option_zsxm = fxxx.option_zsxm;
        const option_zsxm_title = app.translator.trans("ziven-u2di.forum.option-zsxm-"+fxxx.option_zsxm_title);
        const option_lxdh = fxxx.option_lxdh;
        const option_lxdh_wx_value = fxxx.option_lxdh_wx_value;
        const option_wx = fxxx.option_lxdh_checked===1?option_lxdh_wx_value:"同手机";
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+zcxx.option_zclb);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        const option_zcdb = app.translator.trans("ziven-u2di.forum.option-zcdb-"+zcxx.option_zcdb);

        let infoName = option_zcqs+option_lzxz+option_zclb;

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);
        const infoFlag = infoBaseData.flag();

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }

        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let infoDetails = "";
        if(u2diUserType9===true){
            infoDetails = "<span class='u2diItemInfoDetailsButton' id='u2diItemInfoDetailsButton"+currentTimestamp+"'>详情</span>";
        }

        let info = [];

        info.push('<div style="width:360px;color: var(--control-color);padding: 0px 5px;">');

        info.push('<div class="u2diItemDetailsHeaderContainier">');
        info.push('<div style="font-size:20px;margin-top: -10px;text-align: center;"><div>'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span>'+infoDetails+'</div><div style="font-size: 12px;text-align: center;padding-top: 5px;display: flex;justify-content: center;align-items: center;"><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'次'+infoVerifiedSign+'<span style="margin-left:5px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div></div>');
        info.push('<div style="width: 200px;">');
        info.push('<div class="u2diItemDetailsInfoSlimContainer">');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoAreaSize+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+option_synx+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
        info.push('</div>');
        info.push('<div>');
        info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
        info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+infoWantedPrice+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');
        info.push('</div>');

        info.push('<div style="text-align: center;padding-top:0px;" class="u2diItemDetailsViewsContainier">');
        info.push('<div style="width: 140px;">');
        info.push('<div style="font-size: 12px;color: var(--primary-color);">'+infoName+'</div>');
        info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">有'+infoDistributes+'人分销，有'+infoQueries+'人询地</div>');
        info.push('<div style="font-size: 16px;color: '+(userSigned===0?'var(--primary-color)':'#A17EFF')+';padding-top: 10px;">'+option_zsxm+' <span style="font-size: 12px;color: gray;">'+option_zsxm_title+'</span> <span style="font-size: 12px;color: #70B603;">('+infoUserType+')</span></div>');
        info.push('<div style="font-size: 16px;color: #70B603;padding-top: 10px;">'+option_lxdh+'</div>');
        info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">（微信 '+option_wx+'）</div>');
        info.push('</div>');
        info.push('<div style="position:relative">');
        info.push('<textarea disabled id="u2diInfoNoteInputArea'+currentTimestamp+'" style="width: 200px;height: 120px;border: 0px;border-radius: 4px;resize: none;padding: 5px;">'+infoNote+'</textarea><div style="display:none;position: absolute;right: 8px;bottom: 8px;" id="u2diInfoNoteInputAreaStatus'+currentTimestamp+'">分销笔记 已保存</div>');
        info.push('</div>');

        info.push('</div>');


        info.push('</div>');

        callback(info.join(""),infoDistributeData,infoDistributeData,infoDetailsData);
    });
}

function getInfoAdminContent(itemID,currentTimestamp,callback){
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    app.store
      .find("u2diInfoBase/a",{itemID:itemID})
      .catch(() => {})
      .then((result) => {
        const infoBaseData = result[0];
        const u2diUserData = infoBaseData.u2diUserData();
        const userSigned = u2diUserData?u2diUserData.attribute("u2diUserSigned"):0;

        const infoDetailsData = infoBaseData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoCategory = infoBaseData.category();
        const infoNote = infoBaseData.note()===null?"":infoBaseData.note();
        const infoUserType = app.translator.trans("ziven-u2di.forum.user-type-"+infoBaseData.userType());
        const infoStatus = infoBaseData.status();
        const infoIsImport = infoBaseData.import();
        const infoType = infoBaseData.type();
        const infoPrice = infoBaseData.price();
        const infoSignedMark = infoBaseData.signedMark();
        const itemColor = getItemColor(infoType);

        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-left: 5px;color: #04aa41;font-size: 14px;"><i class="fas fa-check-circle"></i></span>';
        }

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const lxxx = JSON.parse(CryptoJSAesJson.decrypt(infoDetailsData.lxxx(), (infoDetailsData.base_id()).toString()));
        const option_zsxm = lxxx.option_zsxm;
        const option_zsxm_title = app.translator.trans("ziven-u2di.forum.option-zsxm-"+lxxx.option_zsxm_title);
        const option_lxdh = lxxx.option_lxdh;
        const option_lxdh_wx_value = lxxx.option_lxdh_wx_value;
        const option_wx = lxxx.option_lxdh_checked===1?option_lxdh_wx_value:"同手机";
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+infoType);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        const option_zcdb = app.translator.trans("ziven-u2di.forum.option-zcdb-"+zcxx.option_zcdb);

        let infoName = option_zcqs+option_lzxz+option_zclb;

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);
        const infoFlag = infoBaseData.flag();

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }

        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let infoDetails = "";
        if(u2diUserType9===true){
            infoDetails = "<span class='u2diItemInfoDetailsButton' id='u2diItemInfoDetailsButton"+currentTimestamp+"'>详情</span>";
        }

        let info = [];

        if(infoIsImport===1){
            info.push('<div style="width:250px;color: var(--control-color);padding: 0px 10px;">');
            info.push('<div class="u2diItemDetailsHeaderContainier">');
            info.push('<div style="font-size:20px;width: 130px;">'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span></div>');
            info.push('<div style="text-align: right;">');
            info.push('<div class="u2diItemDetailsCompletedButton">'+infoPrice+' '+infoPriceUnit+'</div>');
            info.push('</div>');
            info.push('</div>');
            info.push('<div class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 130px;"><div>'+option_zclb+'</div></div>');
            info.push('<div style="text-align: center;">成交价格</div>');
            info.push('</div>');
        }else{
            info.push('<div style="width:360px;color: var(--control-color);padding: 0px 5px;">');
    
            info.push('<div class="u2diItemDetailsHeaderContainier">');
            info.push('<div style="font-size:20px;margin-top: -10px;text-align: center;"><div>'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span>'+infoDetails+'</div><div style="font-size: 12px; text-align: center; padding-top: 5px; display: flex; align-items: center; justify-content: center;"><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'次'+infoVerifiedSign+'<span style="margin-left:5px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div></div>');
            info.push('<div style="width: 200px;">');
            info.push('<div class="u2diItemDetailsInfoSlimContainer">');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+(infoAreaSize===""?"-":infoAreaSize)+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+(option_synx===""?"-":option_synx)+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue" style="margin-top: 5px;">'+(option_yqjg===""?"-":infoWantedPrice)+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
            info.push('</div>');
            info.push('</div>');
            info.push('</div>');
            info.push('</div>');
    
            info.push('<div style="text-align: center;padding-top:0px;" class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 140px;">');
    
            info.push('<div style="font-size: 12px;color: var(--primary-color);">'+infoName+'</div>');
            info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">有'+infoDistributes+'人分销，有'+infoQueries+'人询地</div>');
            info.push('<div style="font-size: 16px;color: '+(userSigned===0?'var(--primary-color)':'#A17EFF')+';padding-top: 10px;">'+option_zsxm+' <span style="font-size: 12px;color: gray;">'+option_zsxm_title+'</span> <span style="font-size: 12px;color: #02A7F0;">('+infoUserType+')</span></div>');
            info.push('<div style="font-size: 16px;color: #02A7F0;padding-top: 10px;">'+option_lxdh+'</div>');
            info.push('<div style="font-size: 12px;color: gray;padding-top: 5px;">（微信 '+option_wx+'）</div>');
    
            info.push('</div>');
            info.push('<div style="position:relative">');
            info.push('<textarea id="u2diInfoNoteInputArea'+currentTimestamp+'" style="width: 200px;height: 120px;border: 0px;border-radius: 4px;resize: none;padding: 5px;">'+infoNote+'</textarea><div style="display:none;position: absolute;right: 8px;bottom: 8px;" id="u2diInfoNoteInputAreaStatus'+currentTimestamp+'">管理笔记 已保存</div>');
            info.push('</div>');
    
            info.push('</div>');
            info.push('</div>');
        }

        callback(info.join(""),infoBaseData,infoBaseData,infoDetailsData);
    });
}

function getInfoContent(itemID,currentTimestamp,callback){
    app.store
      .find("u2diInfoBase/y",{itemID:itemID})
      .catch(() => {})
      .then((result) => {
        const infoBaseData = result[0];

        const infoDetailsData = infoBaseData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoIsImport = infoBaseData.import();
        const infoCategory = infoBaseData.category();
        const infoStatus = infoBaseData.status();
        const infoPrice = infoBaseData.price();
        const infoType = infoBaseData.type();
        const infoFlag = infoBaseData.flag();
        const infoJjType = infoBaseData.jjType();
        const itemColor = getItemColor(infoType);
        const infoSignedMark = infoBaseData.signedMark();

        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-right: 5px;color: #04aa41;"><i class="fas fa-check-circle"></i></span>';
        }

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const option_zpzl_length = zcxx.option_zpzl.length;
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+infoType);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        const option_zcdb = app.translator.trans("ziven-u2di.forum.option-zcdb-"+zcxx.option_zcdb);
        let infoName = option_zcqs+option_lzxz+option_zclb;
        let infoIsYs = zcxx.option_lzxz==="ys";

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }

        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let info = [];

        info.push('<div style="width:250px;color: var(--control-color);padding: 0px 10px;">');
        info.push('<div class="u2diItemDetailsHeaderContainier" style="padding-top: 5px;">');
        info.push('<div style="font-size:20px;width: 130px;">'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span></div>');
        info.push('<div style="text-align: right;">');

        if(infoStatus===1 || infoIsImport===1){
            info.push('<div class="u2diItemDetailsCompletedButton">'+infoPrice+' '+infoPriceUnit+'</div>');
        }else{
            info.push('<div class="u2diItemDetailsQueryButton">'+app.translator.trans("ziven-u2di.forum.item-details-consult")+'&nbsp;<span style="font-size: 12px;color: gray;">'+infoQueries+app.translator.trans("ziven-u2di.lib.unit-times")+'</span></div>');
        }

        info.push('</div>');
        info.push('</div>');

        if(infoStatus===1 || infoIsImport===1){
            info.push('<div class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 130px;"><div>'+option_zclb+'</div></div>');
            info.push('<div style="text-align: center;">成交价格</div>');
            info.push('</div>');
        }else{
            info.push('<div class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 130px;"><div><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'</div></div>');
             
            if(infoFlag!==1 && infoJjType!==1){
                info.push('<div style="text-align: center;">有'+infoDistributes+'人分销</div>');
            }

            info.push('</div>');

            info.push('<div class="u2diItemDetailsContentContainier" style="padding: 10px 0px 0px 0px;">');
            info.push(infoVerifiedSign+""+infoName);
            info.push('</div>');

            info.push('<div class="u2diItemDetailsInfoContainier" style="padding-top: 10px; grid-template-rows: 1.6em 1.6em; grid-template-columns: 1fr 60px 1fr; grid-template-areas: none;">');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+infoAreaSize+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+option_synx+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+infoWantedPrice+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
            info.push('</div>');
            info.push('</div>');

            info.push('<div class="u2diItemDetailsMiscContainier" style="padding-bottom: 0px;">');

            if(infoIsYs===true){
                info.push('<div style="width: 170px; padding: 0px 0px 0px 10px;align-items: center;" class="u2diItemDetailsMiscDeposit">土地招商<span style="margin-left:10px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div>');
                info.push('<div class="u2diItemDetailsReportButton">我要报错</div>');
            }else{
                if(infoFlag===1){
                    info.push('<div style="display:flex;align-items: center;"><div style="display:inline-block;white-space:nowrap;padding:0px;cursor:pointer;width:fit-content" class="u2diItemDetailsMiscDeposit">浏览照片（'+option_zpzl_length+'张）</div><span id="u2diCardVideoLink'+currentTimestamp+'"></span></div>');
                    info.push('<div><div style="margin-left: 50px;" class="u2diItemDetailsReportButton">我要报错</div></div>');
                }else{
                    info.push('<div style="width: 170px; padding: 0px 0px 0px 10px;align-items: center;" class="u2diItemDetailsMiscDeposit">'+option_zcdb+'<span style="margin-left:10px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div>');
                    info.push('<div class="u2diItemDetailsReportButton">我要报错</div>');
                }
            }

            info.push('</div>');
            info.push('</div>');
        }

        callback(info.join(""),infoBaseData,infoBaseData,infoDetailsData);
    });
}

function getInfoYouKeContent(itemID,currentTimestamp,callback){
    app.store
      .find("u2diInfoBase/y",{itemID:itemID})
      .catch(() => {})
      .then((result) => {
        const infoBaseData = result[0];
        const currentUserID = app.session.user.id();
        const infoUserID = infoBaseData.userID();
        const distributeID = infoBaseData.distributeID();
        const infoStatus = infoBaseData.status();
        const infoIsImport = infoBaseData.import();

        const infoDetailsData = infoBaseData.u2diDetailsData();
        const infoSN = infoBaseData.sn();
        const infoViews = formatView(infoBaseData.views());
        const infoQueries = infoBaseData.queries();
        const infoDistributes = infoBaseData.distributes();
        const infoCategory = infoBaseData.category();
        const infoPrice = infoBaseData.price();
        const infoType = infoBaseData.type();
        const infoFlag = infoBaseData.flag();
        const infoJjType = infoBaseData.jjType();
        const itemColor = getItemColor(infoType);
        const infoSignedMark = infoBaseData.signedMark();
        let infoVerifiedSign = "";

        if(infoSignedMark===1){
            infoVerifiedSign = '<span style="margin-right: 5px;color: #04aa41;"><i class="fas fa-check-circle"></i></span>';
        }

        const zcxx = JSON.parse(infoDetailsData.zcxx());
        const jjxx = JSON.parse(infoDetailsData.jjxx());
        const option_zpzl_length = zcxx.option_zpzl.length;
        const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+zcxx.option_zcqs);
        const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+zcxx.option_lzxz);
        const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+infoType);
        const option_synx = zcxx.option_synx;
        const option_tdmj = zcxx.option_tdmj;
        const option_jzmj = zcxx.option_jzmj;
        const option_yqjg = jjxx.option_yqjg;
        let infoName = option_zcqs+option_lzxz+option_zclb;
        let infoUserTypeText = app.translator.trans("ziven-u2di.forum.published-by-user-type-"+infoBaseData.userType());

        let infoCategoryIcon = "";
        let infoAreaSize = "";
        let infoAreaUnit = "";
        let infoPriceUnit = getItemUnit(infoCategory,jjxx);

        if(infoCategory==="jzwz"){
            const icon = infoFlag===1?"fas fa-home":"fas fa-city";
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="'+icon+'"></i>';
            infoAreaSize = option_jzmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
        }else if(infoCategory==="tdwz"){
            infoCategoryIcon = '<i style="padding-right: 5px;color:rgb('+itemColor+')" class="fas fa-th-large"></i>';
            infoAreaSize = option_tdmj;
            infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
        }
        
        infoAreaSize = getInfoSize(infoAreaSize);

        let infoWantedPrice = getInfoWantedPrice(option_yqjg);
        let info = [];

        info.push('<div style="width:250px;color: var(--control-color);padding: 0px 10px;">');

        info.push('<div class="u2diItemDetailsHeaderContainier" style="padding-top: 5px;">');
        info.push('<div style="font-size:20px;width: 130px;">'+infoCategoryIcon+'<span style="background: rgba('+itemColor+');color: #333333;padding: 4px;border-radius: 4px;">'+infoSN+'</span></div>');
        info.push('<div style="text-align: right;">');

        if(infoStatus===1 || infoIsImport===1){
            info.push('<div class="u2diItemDetailsCompletedButton">'+infoPrice+' '+infoPriceUnit+'</div>');
        }else{
            if(infoUserID==currentUserID){
                info.push('<div class="u2diItemDetailsOwnerButton">'+app.translator.trans("ziven-u2di.forum.item-owner")+'</div>');
            }else{
                if(distributeID===null){
                    if(infoFlag===1 || infoJjType===1){
                        info.push('<div class="u2diItemDetailsCannotDistributeButton">无法分销</div>');
                    }else{
                        info.push('<div class="u2diItemDetailsDistributeButton">'+app.translator.trans("ziven-u2di.forum.item-details-join-distribute")+'</div>');
                    }
                }else{
                    info.push('<div class="u2diItemDetailsInDistributeButton">'+app.translator.trans("ziven-u2di.forum.item-details-in-distribute")+'</div>');
                }
            }
        }

        info.push('</div>');
        info.push('</div>');

        if(infoStatus===1 || infoIsImport===1){
            info.push('<div class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 130px;"><div>'+option_zclb+'</div></div>');
            info.push('<div style="text-align: center;">成交价格</div>');
            info.push('</div>');
        }else{
            info.push('<div class="u2diItemDetailsViewsContainier">');
            info.push('<div style="width: 130px;"><div><i style="padding-right: 5px;" class="fas fa-eye"></i>'+infoViews+'</div></div>');
            
            if(infoFlag!==1 && infoJjType!==1){
                info.push('<div style="text-align: center;">有'+infoDistributes+'人分销</div>');
            }

            info.push('</div>');

            info.push('<div class="u2diItemDetailsContentContainier" style="padding: 10px 0px 0px 0px;">');
            info.push(infoVerifiedSign+""+infoName);
            info.push('</div>');

            info.push('<div class="u2diItemDetailsInfoContainier" style="padding-top: 10px; grid-template-rows: 1.6em 1.6em; grid-template-columns: 1fr 60px 1fr; grid-template-areas: none;">');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-area')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+infoAreaSize+'<span class="u2diItemDetailsInfoValueUnit">'+infoAreaUnit+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-years-limit')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+option_synx+'<span class="u2diItemDetailsInfoValueUnit">'+app.translator.trans('ziven-u2di.lib.unit-year')+'</span></div>');
            info.push('</div>');
            info.push('<div>');
            info.push('<div class="u2diItemDetailsInfoTitle">'+app.translator.trans('ziven-u2di.forum.item-details-price')+'</div>');
            info.push('<div class="u2diItemDetailsInfoValue">'+infoWantedPrice+'<span class="u2diItemDetailsInfoValueUnit">'+infoPriceUnit+'</span></div>');
            info.push('</div>');
            info.push('</div>');

            info.push('<div class="u2diItemDetailsMiscContainier" style="padding-bottom: 0px;">');

            if(infoFlag===1){
                info.push('<div style="display:flex"><div style="display:inline-block;white-space:nowrap;padding:0px;cursor:pointer;width:fit-content" class="u2diItemDetailsMiscDeposit">浏览照片（'+option_zpzl_length+'张）</div><span id="u2diCardVideoLink'+currentTimestamp+'"></span></div>');
                info.push('<div><div style="margin-left: 50px;" class="u2diItemDetailsReportButton">我要报错</div></div>');
            }else{
                info.push('<div style="align-items: center;" class="u2diItemDetailsMiscDeposit">'+infoUserTypeText+'<span style="margin-left:10px" id="u2diCardVideoLink'+currentTimestamp+'"></span></div>');
                info.push('<div class="u2diItemDetailsReportButton">我要报错</div>');
            }

            info.push('</div>');

            info.push('</div>');
        }

        callback(info.join(""),infoBaseData,infoBaseData,infoDetailsData);
    });
}

function formatView(viewCount){
    if(viewCount>=1000){
        viewCount = (1123/1000).toFixed(1)+"k";
    }

    return viewCount;
}